// extracted by mini-css-extract-plugin
export default {"container":"CheckBoxItem_container__rRFNK"};